import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';

const appRoot = document.getElementById('jointSealant');
const el = ReactDOM.createRoot(appRoot);

const locale = appRoot.getAttribute('data-locale');
const country = appRoot.getAttribute('data-country');
const context = appRoot.getAttribute('data-context');
const groutKey = appRoot.getAttribute('data-grout-key');

window.dataLayer = window.dataLayer || [];

if (typeof(window.dataLayer) !== 'undefined') {
    console.log('dataLayer defined');

    var dataLayer = window.dataLayer;
    console.log(dataLayer);
}

el.render(
    <App
        locale={ locale || "en-AU" }
        context={ context || "int" }
        country={country || "uk"}
        groutKey={groutKey || null}
        dataLayer={dataLayer || null}
    />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
